import { Category, CategoryEntityType } from "@/types/category";

export interface CreateCategoryDto {
  name: string;
  icon?: string;
  entityType: CategoryEntityType;
  isPriority?: boolean;
  order?: number;
  hotelId: string;
}

export type UpdateCategoryDto = Partial<CreateCategoryDto> & {
  isArchived?: boolean;
};

export interface CategoryFilters {
  entityType: CategoryEntityType;
  search?: string;
  page: number;
  limit: number;
  hotelId: string;
}

export interface CategoryFindAllResponse {
  items: Category[];
  page: number;
  totalPages: number;
}

export enum ReorderEntityType {
  CATEGORY = "CATEGORY",
  FAQ = "FAQ",
  CANNED_RESPONSE = "CANNED_RESPONSE",
}

export interface ReorderDto {
  ids: string[];
  hotelId: string;
  type: ReorderEntityType;
  startIndex?: number;
}

export interface ICategoryService {
  findAll(filters: CategoryFilters): Promise<CategoryFindAllResponse>;
  create(data: CreateCategoryDto): Promise<Category>;
  update(id: string, data: UpdateCategoryDto): Promise<Category>;
  deleteCategory(id: string): Promise<void>;
  reorder(data: ReorderDto): Promise<void>;
}
